"use client";

import type { CSSProperties, ReactNode } from "react";
import {
    siteBuilderCountdownLabel,
    useSiteBuilderCountdown,
} from "./siteBuilderCountdown";

export function SiteBuilderCountdown({
    languageCode,
    outlineOwner = false,
    style,
    targetDate,
    title,
    titleAttributes,
    titleStyle,
}: {
    languageCode: string;
    outlineOwner?: boolean;
    style?: CSSProperties;
    targetDate: string;
    title: ReactNode;
    titleAttributes?: Record<string, string | boolean | undefined>;
    titleStyle?: CSSProperties;
}) {
    const items = useSiteBuilderCountdown(targetDate);

    return (
        <time
            className="site-builder-countdown"
            data-builder-outline-owner={outlineOwner ? "true" : undefined}
            dateTime={targetDate || undefined}
            style={{ display: "inline-block", ...style }}
            suppressHydrationWarning
        >
            {title ? (
                <strong
                    {...titleAttributes}
                    className="site-builder-countdown-title"
                    style={titleStyle}
                >
                    {title}
                </strong>
            ) : null}
            <span className="site-builder-countdown-values">
                {items.map((item) => (
                    <span
                        className="site-builder-countdown-value"
                        key={item.labelKey}
                    >
                        <b>{item.text}</b>
                        <small>
                            {siteBuilderCountdownLabel(languageCode, item.labelKey)}
                        </small>
                    </span>
                ))}
            </span>
        </time>
    );
}
